module.exports = __webpack_public_path__ + "static/media/log.c0f8bbf2.svg";